import styled from 'styled-components';
import { Button } from '@mui/material';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 500px;
  padding: 24px;
  padding-bottom: 80px;
  position: relative;
`;

export const ProgressContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
`;

export const ProgressDots = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${({ active, completed }) => 
    completed ? '#4caf50' : active ? '#1976d2' : '#e0e0e0'};
  transition: background-color 0.3s ease;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  justify-content: center;
  width: 100%;
  max-width: 600px;
`;

export const QuestionContainer = styled.div`
  text-align: center;
  margin-bottom: 32px;
  max-width: 600px;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 500px;
`;

export const OptionButton = styled(Button)`
  height: 56px;
  justify-content: flex-start;
  padding: 16px 24px;
  text-transform: none;
  font-size: 16px;
  border-radius: 8px;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const MultiSelectContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 24px;
`;

export const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: calc(100% - 48px);
  margin-top: auto;
  padding-top: 24px;
  position: absolute;
  bottom: 24px;
  left: 24px;
`;